const Contacto = () => {
    return (
        <div className="border-solid border-2 border-gray-300 mt-14 ml-5 md:ml-40 md:mr-40 mr-4 pl-10 pt-10 pb-10">
            <h1 className="font-bold text-3xl" >Contacto</h1>
            
            <div className="mt-7">
                <h4 className="font-bold text-xl" >Alejandro Bermúdez Cabrera</h4>
                <p className="text-sm">Director de ventas comerciales</p>
                <p className="text-sm">Tel. (999) 942 09 00 Ext. 10731/10730</p>
                <p className="text-sm">alejandro.bermudez@proteinol.com.mx</p>
            </div>
            
            <div className="mt-7">
                <h4 className="font-bold text-xl" >Jorge W. Goff Ailloud</h4>
                <p className="text-sm">Director de ventas industriales</p>
                <p className="text-sm">Tel. (999) 942 09 00 Ext. 10134 /10133</p>
                <p className="text-sm">jorge.goff@proteinol.com.mx</p>
            </div>
            
            <div className="mt-7">
                <h4 className="font-bold text-xl" >Ricardo J. Acevedo Vales</h4>
                <p className="text-sm">Gerente de ventas subproductos</p>
                <p className="text-sm">Tel. (999) 942 09 00 Ext. 10138/10136</p>
                <p className="text-sm">Ricardo.acevedo@proteinol.com.mx</p>
            </div>
            
            <div className="mt-7">
                <h4 className="font-bold text-xl" >Javier Cervera Contreras</h4>
                <p className="text-sm">Director de relaciones industriales</p>
                <p className="text-sm">Tel. (999) 942 09 00 Ext. 10018/10010</p>
                <p className="text-sm">atencionrh@proteinol.com.mx</p>
            </div>

        </div>
    )
}

export default Contacto;